"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import { emailService } from "../services/email_service";
import DisablingButton from "../components/disabling_button";
class MarkEmailCompleteView extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { includeException: false });
    __publicField(this, "possibleCompletionOptions", () => {
      var _a;
      var email = this.props.email;
      if (email.parent && _.some((_a = email.parent.exceptioned_items) != null ? _a : [], function(item) {
        return item.state !== "complete";
      })) {
        return /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              checked: this.state.includeException || false,
              onChange: (e) => this.setState({
                includeException: e.target.checked
              })
            }
          ),
          " ",
          "Ignore the original invoice and remove from my dashboard as well."
        ] });
      }
    });
    __publicField(this, "markComplete", () => {
      this.setState({ completing: true });
      emailService.markComplete(this.props.email, !this.state.includeException, null, true).then(() => {
        this.props.onMarkCompleteFinished();
        this.setState({ completing: false });
      });
    });
  }
  render() {
    window.email = this.props.email;
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "MarkEmailCompleteView",
        className: "modal__medium-container reply__mark-complete",
        children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
          /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx("h3", { children: "Ignore this entry." }) }),
          /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx("p", { children: "Ignoring this entry will remove it from your dashboard." }) }),
          this.possibleCompletionOptions(),
          /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
            /* @__PURE__ */ jsx(
              DisablingButton,
              {
                disabled: this.state.completing,
                disabledText: "Completing...",
                onClick: this.markComplete,
                className: "button--confirmation",
                children: "Ignore This Entry"
              }
            ),
            " ",
            "\xA0",
            /* @__PURE__ */ jsxs("span", { className: "button--cancel-wrapper", children: [
              /* @__PURE__ */ jsx("span", { children: "or" }),
              /* @__PURE__ */ jsx("button", { className: "button--cancel", onClick: this.props.onCancel, children: "cancel" })
            ] })
          ] })
        ] })
      }
    );
  }
}
export default MarkEmailCompleteView;
